export default {
  state: {
    certifyApiCode: null,
    choice: {
      memberInfo: {},
      loginSite: "",
      transferType: ""
    },
    localSigninInfo: {},
    localToken: {
      access_token: "",
      expires_in: 0,
      refresh_token: "",
      refresh_token_expires_in: 0,
      scope: "",
      token_type: ""
    },
    serviceAccountList: [],
    sessionToken: "",
    transferResult: {}
  },
  mutations: {
    INIT_TRANSFER_ACCOUNT_LIST(state) {
      state.serviceAccountList = [];
    },
    SETTING_TRANSFER_ACCOUNT_LIST(state, accountList) {
      state.serviceAccountList = accountList;
    },
    SET_SSO_SUGGEST_ACCOUNTS(state, accountList) {
      state.serviceAccountList = [];
      if (accountList.length) {
        accountList.forEach((account) => {
          const info = {
            country_number_id: "+82",
            email_id: account.id || "",
            id_type: account.id_type || "",
            is_legacy: !!account.is_legacy,
            is_transfer: !!account.is_transfer,
            member_no: account.service_member_no,
            multi_flag: account.multi_flag,
            phone_no_id: "",
            social_type: account.social_type
          };
          state.serviceAccountList.push(info);
        });
      }
    },
    INIT_TRANSFER_CERTIFY_INFO(state, loginSite) {
      state.choice.memberInfo = {};
      state.choice.transferType = "";
      state.choice.loginSite = loginSite;
    },
    SETTING_TRANSFER_ACCOUNT_CERTIFY_INFO(state, info) {
      state.choice.memberInfo = info.memberInfo;
      state.choice.transferType = info.transferType;
    },
    SETTING_LOCAL_ACCOUNT_INFO(state, info) {
      state.localSigninInfo = info;
    },
    INIT_CERTIFY_API_CODE(state) {
      state.certifyApiCode = null;
    },
    SETTING_CERTIFY_API_CODE(state, code) {
      state.certifyApiCode = code;
    },
    SETTING_TRANSFER_SUCCESS_RESULT(state, result) {
      state.transferResult = result;
    }
  }
};
